import store from '../../store';
import Router from '../../router';
import { v4 as uuidv4 } from 'uuid';

const checkinSessionId = uuidv4();
sessionStorage.setItem('chk_session_id', checkinSessionId);

export const interceptorResponse = (config) => {
  const mdmId = store.state.mdm?.data?.id;
  const cpfSearched = store.state.cpfSearched?.data?.cpf;

  const telemetryData = {
    dataType: Router.currentRoute?.name,
    userId: mdmId || cpfSearched ? `${cpfSearched}_${mdmId}` : null,
    traceId: sessionStorage.getItem('chk_session_id'),
  };

  config.headers['telemetry-data'] = JSON.stringify(telemetryData);

  return config;
};
